export const EnumNotifications = {
    preScheduling: 0,
    notification: 1
}